import { type BasePerformanceRequestFilterParams } from "features/Library/Common/models";
import { sendExportRequest } from "features/Library/Common/utils/performanceUtils";
import { embeddedVideosDataService } from "../../services/embeddedVideosDataService";

export const getEmbeddedVideoPeopleDetailsExport = (
  embeddedVideoId: number,
  params: BasePerformanceRequestFilterParams,
  embeddedVideoTitle: string,
) => {
  let abortController = new AbortController();
  return sendExportRequest(
    (abortController) => embeddedVideosDataService.getEmbeddedVideoExport(params, embeddedVideoId),
    embeddedVideoTitle,
    abortController,
  );
};
